// extracted by mini-css-extract-plugin
module.exports = {"notfound":"NotFound_notfound__16StR","main":"NotFound_main__34O4W","text":"NotFound_text__TVIIg","not":"NotFound_not__3FBR3","blueBtn":"NotFound_blueBtn__35E9-"};